import { mediaMatch } from "../../../../utils";
import cookies from "../../../../utils/cookies";

const isMdmax = mediaMatch.isMdmax;
const { passId } = cookies.getUserInfo();
const { agentId } = cookies.getAgentInfo();

const initialState = {
  loading: false,
  integralList: [],
  query: {
    page: 1,
    limit: isMdmax ? 5 : 10,
    passId,
    agentId
  },
  total: 0,
};

function reducer(state, action) {
  switch (action.type) {
    case "setLoading":
      return { ...state, loading: action.payload };
    case "setIntegralList":
      return { ...state, integralList: action.payload };
    case "setTotal":
      return { ...state, total: action.payload };
    case "setQuery":
      return { ...state, query: action.payload };
    default:
  }
}

const setLoading = (payload) => ({
  type: "setLoading",
  payload,
});

const setTotal = (payload) => ({
  type: "setTotal",
  payload,
});

const setIntegralList = (payload) => ({
  type: "setIntegralList",
  payload,
});

const setQuery = (payload) => ({
  type: "setQuery",
  payload,
});

export {
  initialState,
  reducer,
  setTotal,
  setLoading,
  setQuery,
  setIntegralList,
};
